import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LoaderButton from '../LoaderButton/LoaderButton';
import DatePicker from '../Fields/DatePicker/DatePicker';
import './PickupDateBar.scss';

const PickupDateBar = ({
  handlePickupDateChange,
  handlePickupDateSubmit,
  isPickupDateSubmitDisabled,
  isLoadingPickupDate,
  isLoadingTransferredForTransportLoading,
  handleSetTransferredForTransportSubmit,
  isLoadingPickedUpDate,
  pickupDateLabel,
  datepickerPlaceholder,
  pickupDateSubmitLabel,
  transferredForTransportLabel,
  pickedupSubmitLabel,
  pickedupCheckboxLabel,
  isStatusSentForTransport,
  isEasyTransportOn,
  sendDateToSellerLabel,
  handlePickedupSubmit,
  sendLabel,
  cancelLabel,
}) => {
  const transferredForTransportClassNames = classNames('submit-button labels labels__right', {
    'transferred-for-transport': isStatusSentForTransport,
  });
  const isVehicleWasPickedUpDisable = (typeof pickupDateLabel === 'string');


  return (
    <div className="pickup-date-bar">
      <div className="labels__container">
        <LoaderButton
          label={pickupDateSubmitLabel}
          type="button"
          dataToggle="modal"
          dataTarget="#date-picker-modal"
          className="submit-button labels labels__right"
          isLoading={isLoadingPickupDate}
        />
        <DatePicker
          placeholder={datepickerPlaceholder}
          onChange={handlePickupDateChange}
          disabled={isPickupDateSubmitDisabled}
          handlePickupDateSubmit={handlePickupDateSubmit}
          handleSetTransferredForTransportSubmit={handleSetTransferredForTransportSubmit}
          isLoading={isLoadingTransferredForTransportLoading}
          pickupLabel={isEasyTransportOn ? pickupDateSubmitLabel : transferredForTransportLabel}
          isEasyTransportOn={isEasyTransportOn}
          sendDateToSellerLabel={sendDateToSellerLabel}
          cancelLabel={cancelLabel}
          sendLabel={sendLabel}
          isVehicleWasPickedUpDisable={isVehicleWasPickedUpDisable}
        />
        {isEasyTransportOn &&
          <LoaderButton
            label={transferredForTransportLabel}
            type="button"
            dataToggle="modal"
            dataTarget="#easy-transport-modal"
            disabled={isStatusSentForTransport}
            className={transferredForTransportClassNames}
            isLoading={isLoadingPickupDate || isLoadingTransferredForTransportLoading}
          />
        }
        <LoaderButton
          isLoading={isLoadingPickedUpDate}
          label={pickedupSubmitLabel}
          dataToggle="modal"
          dataTarget="#vehicle-was-picked"
          className="submit-button labels labels__right"
        />
      </div>
      <div
        id="vehicle-was-picked"
        className="modal fade vehicle-was-picked"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
              ><i className="fa fa-times" /></button>
              <h4 className="modal-title">{pickedupSubmitLabel}</h4>
            </div>
            <div className="modal-body text-center">
              <h4 className="modal-title">
                {pickedupCheckboxLabel}
              </h4>
            </div>
            <div className="modal-footer">
              <button
                data-dismiss="modal"
                className="labels labels__right cancel-button"
              >{cancelLabel}
              </button>
              <LoaderButton
                label={sendLabel}
                className="submit-button labels labels__right"
                onClick={handlePickedupSubmit}
                isLoading={isLoadingPickupDate || isLoadingTransferredForTransportLoading}
                dataDismiss="modal"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PickupDateBar.propTypes = {
  handlePickupDateChange: PropTypes.func,
  handlePickupDateSubmit: PropTypes.func,
  isPickupDateSubmitDisabled: PropTypes.bool,
  isLoadingPickupDate: PropTypes.bool,
  isLoadingTransferredForTransportLoading: PropTypes.bool,
  isLoadingPickedUpDate: PropTypes.bool,
  pickupDateLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  datepickerPlaceholder: PropTypes.string,
  pickupDateSubmitLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  sendDateToSellerLabel: PropTypes.string.isRequired,
  transferredForTransportLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isPickedUpSubmitDisabled: PropTypes.bool,
  pickedupSubmitLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  pickedupCheckboxLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  handleSetTransferredForTransportSubmit: PropTypes.func,
  handlePickedupSubmit: PropTypes.func.isRequired,
  isStatusSentForTransport: PropTypes.bool,
  isEasyTransportOn: PropTypes.bool,
  sendLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string.isRequired,
  easyTransport: PropTypes.string,
};

PickupDateBar.defaultProps = {
  handlePickupDateChange: null,
  handlePickupDateSubmit: null,
  handleSetTransferredForTransportSubmit: null,
  isPickupDateSubmitDisabled: null,
  isLoadingPickupDate: false,
  isLoadingTransferredForTransportLoading: false,
  isLoadingPickedUpDate: false,
  isEasyTransportOn: null,
  easyTransport: '',
  pickupDateLabel: '',
  datepickerPlaceholder: '',
  pickupDateSubmitLabel: '',
  className: '',
  isPickedUpSubmitDisabled: null,
  pickedupSubmitLabel: '',
  pickedupCheckboxLabel: '',
  transferredForTransportLabel: '',
  isStatusSentForTransport: false,
};

export default PickupDateBar;
